import { createApp, computed } from "vue";
import { useStore } from "vuex";
import router from "./router/index";
import store from "./store";
import App from './App.vue'
import Mixin from '@utils/mixin'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
const app = createApp(App);


// app.use(router).use(store).mount("#app")
app.use(router).use(store).use(mavonEditor).mixin(Mixin).mount("#app");

app.directive('can', async(el, binding, vnode) => {

    const store1 = binding.instance.store;

    console.log(binding.instance.store);
    console.log("---------------")
    console.log(authUser);
    if (authUser && authUser.permissions) {
        if (Array.isArray(permissions)) {
            // Check if the user has any of the specified permissions
            return permissions.some(permission => state.authUser.permissions.includes(permission));
        }
    }
    return false;

})